import { AppFooter } from "design-system/AppShell";

/**
 * Slim global footer. Mono caption against the chrome surface.
 *
 * Provenance — uses the skill-derived `<AppFooter>` primitive.
 */
function Footer() {
  return (
    <AppFooter>
      © {new Date().getFullYear()} · Powered by Western Ava · All rights reserved
    </AppFooter>
  );
}

export default Footer;
